import styled from 'styled-components';

import { LoadingIcon } from '../../icons';
import { rotationCss } from '../../utils/animation.utils';

export const Spinner = styled(LoadingIcon)`
  ${rotationCss}
`;
